var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetch } from 'whatwg-fetch';
import { getEnvApiPrefix } from '../../util';
export function buildIconJsonUrl(env, collection, name) {
    return "https://" + getEnvApiPrefix(env) + "icons.biw.cloud/" + encodeURIComponent(collection) + "/" + encodeURIComponent(name) + ".json";
}
export function validateIconData(thing) {
    if (typeof thing !== 'object' || thing === null)
        throw new Error('Unable to load icon: Icon data is not an object');
    var objectThing = thing;
    if (typeof objectThing['width'] !== 'number')
        throw new Error('Unable to load icon: Icon data is missing a numeric "width" property');
    if (typeof objectThing['height'] !== 'number')
        throw new Error('Unable to load icon: Icon data is missing a numeric "height" property');
    if (typeof objectThing['viewBox'] !== 'string')
        throw new Error('Unable to load icon: Icon data is missing a string "viewBox" property');
    if (!Array.isArray(objectThing['pathData']))
        throw new Error('Unable to load icon: Icon data is missing an array "pathData" property');
    var pathData = objectThing['pathData'];
    if (pathData.some(function (element) { return typeof element !== 'string'; })) {
        throw new Error('Unable to load icon: Not all "pathData" elements are strings');
    }
}
export function fetchIconFromUrl(url, fetchFunction) {
    if (fetchFunction === void 0) { fetchFunction = defaultFetch; }
    return __awaiter(this, void 0, void 0, function () {
        var response, icon, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchFunction(url)];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200) {
                        throw new Error("Unable to load icon: Server returned status code " + response.status + " " + response.statusText);
                    }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    icon = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    throw new Error("Unable to load icon: Server did not return JSON data");
                case 5:
                    validateIconData(icon);
                    return [2 /*return*/, icon];
            }
        });
    });
}
export var defaultFetch = typeof window !== "undefined" ? window.fetch : fetch;
//# sourceMappingURL=api.js.map